import { Fingerprint, Mail, Building2, Chrome } from 'lucide-react';

import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import { Meta, breadcrumbLd } from '../seo/Meta.jsx';
import { startLogin } from '../lib/auth.js';

// Signup screen offers four auth paths. Per ADR 0010 + PRD-003:
//   1. Passkey (featured) - WebAuthn via ZITADEL
//   2. Email + password - default ZITADEL form
//   3. Continue with Google - ZITADEL idp_hint=google
//   4. Continue with Microsoft - ZITADEL idp_hint=microsoft
//
// All paths funnel through /auth/login on the backend which redirects to
// ZITADEL with PKCE. After verification ZITADEL redirects to /auth/callback
// which sets the session cookie and lands the user at /workspace-setup.
export default function Signup() {
  return (
    <>
      <Meta
        title="Create your tender-api workspace"
        description="Sign up for tender-api. Continue with passkey, email, Google, or Microsoft. 30 seconds to a verified workspace."
        path="/signup"
        jsonLd={[
          breadcrumbLd([
            { name: 'tender-api', path: '/' },
            { name: 'Sign up', path: '/signup' },
          ]),
        ]}
      />
      <Header />
      <main className="container" style={{ paddingTop: 'var(--space-10)', paddingBottom: 'var(--space-12)', maxWidth: 480 }}>
        <h1 style={{ fontSize: 'var(--fs-40)', fontWeight: 700, letterSpacing: 'var(--tracking-tight)', margin: 0 }}>
          Create your workspace
        </h1>
        <p style={{ fontSize: 'var(--fs-16)', color: 'var(--fg-2)', marginTop: 12 }}>
          Pick how you want to sign in. You can change methods later from your account settings.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 32 }}>
          <Btn primary onClick={() => startLogin()} icon={<Fingerprint size={18} strokeWidth={2.5} />}>
            Continue with passkey
          </Btn>
          <Btn onClick={() => startLogin()} icon={<Mail size={18} />}>
            Continue with email
          </Btn>
          <Btn onClick={() => startLogin('google')} icon={<Chrome size={18} />}>
            Continue with Google
          </Btn>
          <Btn onClick={() => startLogin('microsoft')} icon={<Building2 size={18} />}>
            Continue with Microsoft
          </Btn>
        </div>

        <p style={{ fontSize: 'var(--fs-12)', color: 'var(--fg-3)', marginTop: 24, lineHeight: 1.5 }}>
          By signing up you agree to our terms and privacy policy. No charges until your card is on file via Stripe Checkout.
        </p>
      </main>
      <Footer />
    </>
  );
}

function Btn({ primary, onClick, icon, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        padding: '14px 18px',
        background: primary ? 'var(--accent)' : 'var(--bg-1)',
        color: primary ? 'var(--accent-fg)' : 'var(--fg-1)',
        border: primary ? 0 : '1px solid var(--line-2)',
        borderRadius: 'var(--r-3)',
        fontWeight: 600,
        fontSize: 'var(--fs-15)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 12,
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      <span aria-hidden="true">{icon}</span>
      <span>{children}</span>
    </button>
  );
}
